import React from 'react'
import NavBar from '../Component/NavBarFooter/NavBar'
import Footer from '../Component/NavBarFooter/Footer'
import Banner from '../Component/AuditReport/Banner'
import ListingAudit from '../Component/AuditReport/ListingAudit'
import BrandSection from '../Component/HomePage/BrandSection'

function AuditReport() {
  return (
    <>
    <NavBar/>
    <Banner/>
    <ListingAudit/>
    <BrandSection/>
    <Footer/>

    </>
  )
}

export default AuditReport